var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArWayLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7325 4.89985C17.2924 4.16547 15.6615 3.7649 13.9448 3.7649C12.2185 3.7649 10.5971 4.17501 9.15698 4.89985L11.0072 1.69528C12.3139 -0.565092 15.5757 -0.565092 16.8823 1.69528L18.7325 4.89985Z",
    fill: "url(#paint0_linear_741_13476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5451 19.95L24.579 14.8093L21.3744 9.26806C21.2218 9.01055 21.0596 8.78165 20.8594 8.59091C20.0391 7.75161 18.866 7.42734 17.7883 7.63716C16.8823 7.81837 16.0334 8.35247 15.5089 9.26806L15.2418 9.72586L14.002 11.8718L17.2351 17.4702L18.6753 19.9595C19.9819 22.2199 18.351 25.043 15.7378 25.043H24.579H24.6076C27.2113 25.0334 28.8422 22.2103 27.5451 19.95Z",
    fill: "url(#paint1_linear_741_13476)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5789 14.3989V14.8185L21.3743 9.27728C21.3552 9.24866 21.3362 9.22005 21.3171 9.19144C21.1836 8.97208 21.031 8.77179 20.8593 8.60012C19.3524 7.04552 16.6533 7.27442 15.4993 9.27728L14.0019 11.8619L11.2933 16.5448L10.7687 17.4604H7.77395C6.01906 17.4604 4.7029 16.1824 4.42631 14.6564C4.30232 13.9792 4.37863 13.2544 4.72197 12.5772C4.73151 12.5582 4.74105 12.5391 4.75059 12.5105C4.76966 12.4628 4.79827 12.4151 4.82688 12.3674L5.11301 11.8715L9.1378 4.8996C10.5779 4.16522 12.2088 3.76465 13.9256 3.76465C15.6519 3.76465 17.2732 4.17476 18.7134 4.8996C19.7243 5.41462 20.6495 6.08224 21.4411 6.87385C21.5364 6.96922 21.6318 7.0646 21.7272 7.16951C23.463 9.03884 24.5312 11.5376 24.5598 14.2749C24.5789 14.313 24.5789 14.3607 24.5789 14.3989ZM3.3009 14.3989V15.0379L0.458747 19.9497C-0.828804 22.1814 0.744869 24.9663 3.3009 25.0331C3.32951 25.0331 3.36766 25.0331 3.39627 25.0331H14.2689V25.0236H14.0019C8.11729 25.0331 3.33905 20.2739 3.3009 14.3989Z",
    fill: "url(#paint2_linear_741_13476)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7378 25.0332H15.0416V25.0236H14.002C8.11742 25.0236 3.33918 20.2645 3.30103 14.3894V14.3226C3.30103 13.9698 3.3201 13.6264 3.35825 13.2926C3.73021 9.64931 5.95243 6.54965 9.06163 4.93782C9.09024 4.92829 9.11885 4.90921 9.14746 4.89014L5.12268 11.862L4.83655 12.3579C4.80794 12.4056 4.77932 12.4533 4.76025 12.501C4.75071 12.5296 4.74118 12.5487 4.73164 12.5678C4.61719 12.8062 4.53135 13.0446 4.47413 13.2926C3.99726 15.3336 5.52324 17.4605 7.78361 17.4605H17.2447L18.6849 19.9497C19.9724 22.2101 18.3415 25.0332 15.7378 25.0332Z",
    fill: "url(#paint3_linear_741_13476)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.1225 11.8716C4.32136 14.0843 5.94272 16.5449 8.41291 16.5449H11.2932L10.7686 17.4605H7.7739C5.23695 17.4605 3.62512 14.7996 4.72193 12.5774C4.73146 12.5583 4.741 12.5392 4.75054 12.5106C4.76961 12.4629 4.79822 12.4152 4.82684 12.3675L5.1225 11.8716Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.9188 17.4604H17.2349L18.6751 19.9497C19.9817 22.2101 18.3508 25.0332 15.7375 25.0332H14.4214C17.0346 25.0332 18.6655 22.2101 17.3589 19.9497L15.9188 17.4604Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.8594 8.59053C21.031 8.7622 21.1836 8.96249 21.3172 9.18185C19.6958 7.93244 17.1874 8.27579 16.062 10.231L14.5551 12.8347L14.002 11.8714L15.4993 9.27722C16.6534 7.26483 19.3524 7.03593 20.8594 8.59053Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_741_13476",
    x1: 19.0092,
    y1: 8.77204,
    x2: 18.5461,
    y2: 2.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9803E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA2069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_741_13476",
    x1: 26.0668,
    y1: 25.0811,
    x2: 12.7312,
    y2: 20.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E54E70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_741_13476",
    x1: 24.6274,
    y1: -1.53942,
    x2: 4.53927,
    y2: 27.9342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_741_13476",
    x1: 3.30126,
    y1: 14.9682,
    x2: 19.1307,
    y2: 14.9682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67F3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F6EEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArWayLight);
export default __webpack_public_path__ + "static/media/ARWay_Light.d5a875317932f16feb8c42b0823cc6d3.svg";
export { ForwardRef as ReactComponent };